let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2mruf")).then(() => parcelRequire('4eAP9'));